"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WickedApiClient_1 = require("./../../../../api/WickedApiClient");
var service_service_1 = require("src/app/Services/service.service");
var conversationService_1 = require("./../../../../Services/conversationService");
var core_1 = require("@angular/core");
var environment_1 = require("src/environments/environment");
var GroupMessagesComponent = /** @class */ (function () {
    function GroupMessagesComponent(mainService, conversationService) {
        this.mainService = mainService;
        this.conversationService = conversationService;
        this.conversations = [];
        this.images = {};
        this.changesHelper = false;
    }
    GroupMessagesComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.scrollToBottom();
        this.msgRef.changes.subscribe(function () {
            _this.scrollToBottom();
        });
    };
    GroupMessagesComponent.prototype.ngOnInit = function () {
        this.messages = this.currentConversation.messages;
        this.scrollToBottom();
    };
    GroupMessagesComponent.prototype.ngOnChanges = function () {
        this.messages = this.currentConversation.messages;
    };
    GroupMessagesComponent.prototype.scrollToBottom = function () {
        var lastMsgRef = document.querySelectorAll(".vng-chat-message:last-child")[0];
        if (lastMsgRef)
            lastMsgRef.scrollIntoView();
    };
    GroupMessagesComponent.prototype.prepareImages = function (message) {
        var images = message.images.map(function (img) {
            return {
                small: environment_1.environment.apiBaseUrl + "/FileGet/" + img.fileName,
                medium: environment_1.environment.apiBaseUrl + "/FileGet/" + img.fileName,
                big: environment_1.environment.apiBaseUrl + "/FileGet/" + img.fileName
            };
        });
        return images;
    };
    return GroupMessagesComponent;
}());
exports.GroupMessagesComponent = GroupMessagesComponent;
